import { useState, useCallback } from 'react';

export function useApiError() {
  const [errorModal, setErrorModal] = useState(null);

  const handleApiError = useCallback((data) => {
    const message = data?.message ?? 'Xəta baş verdi.';
    const raw = data?.validations;
    const validations = Array.isArray(raw) ? raw
      : (raw && typeof raw === 'object') ? raw
      : [];

    window.dispatchEvent(new CustomEvent('api-error', { detail: { message } }));

    const hasValidations = Array.isArray(validations)
      ? validations.length > 0
      : Object.keys(validations).length > 0;

    if (hasValidations) {
      setErrorModal({ message, validations });
    }
  }, []);

  const clearError = useCallback(() => setErrorModal(null), []);

  return { errorModal, clearError, handleApiError };
}
